import SoftSelect from 'components/SoftSelect'
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
import { useRef, useState } from 'react'

import {
  FormControl,
  InputLabel,
  MenuItem,
  Checkbox,
  ListItemText,
  Typography,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

import OutlinedInput from '@mui/material'

import Select from 'react-select'

import styles from 'components/SoftSelect/styles'

import colors from 'assets/theme/base/colors'

export const MultiSelect = ({
  intakeAttribute,
  options,
  label,
  placeholder,
  onChange = (e) => console.log(e),
  moveToNext,
  autoFocus,
  hiddenLabel,
  optionMatchMethod,
}) => {
  const dropdownRef = useRef()

  const selections = [
    {
      id: 'fegli',
      optionLabel: 'Basic Life',
      isFixed: true,
    },
    {
      id: 'fegliOptionA',
      optionLabel: 'Option A',
      isFixed: false,
    },
    {
      id: 'fegliOptionB',
      optionLabel: 'Option B',
      isFixed: false,
    },
    {
      id: 'fegliOptionC',
      optionLabel: 'Option C',
      isFixed: false,
    },
  ]

  const optionsMapping = selections.map(({ id, optionLabel, isFixed }) => ({
    value: id,
    label: optionLabel,
    isFixed: isFixed,
  }))

  //   console.log(optionsMapping)

  const handleChange = (event) => {
    console.log(event)
  }

  return (
    <>
      <SoftBox
        ml={0.5}
        lineHeight={0}
        display={hiddenLabel ? 'none' : 'inline-block'}
      >
        <SoftTypography
          component="label"
          variant="body2"
          fontWeight="regular"
          textTransform="capitalize"
        >
          {label}
        </SoftTypography>
      </SoftBox>
      <SoftSelect
        isMulti
        ref={dropdownRef}
        placeholder={placeholder}
        value={
          {
            value: intakeAttribute,
            label: selections.find(({ value }) => intakeAttribute === value),
          }?.label
        }
        defaultValue={{
          value: selections[0].id,
          label: selections[0].optionLabel,
        }}
        options={optionsMapping}
        // onChange={({ value }) => onChange(value)}
        onChange={handleChange}
        // onKeyPress={moveToNext}
        autoFocus={autoFocus}
      />
      {/* <Select
        label={placeholder}
        multiple
        defaultChecked
        defaultValue={options2[0]}
        value={selected}
        placeholder="TEST"
        renderValue={(selected) => selected.join(', ')}
        
        MenuProps={{
        }}
        onChange={(e) => {
          handleChange(e)
        }}
      >
        {options2.map((option) => (
          <MenuItem key={option.id} value={option.optionLabel}>
            <Checkbox checked={selected.includes(option)} />
            <ListItemText primary={option.optionLabel}>
              {option.optionLabel}
            </ListItemText>
          </MenuItem>
        ))}
      </Select> */}
    </>
  )
}
